export default "__VITE_ASSET__DhlwWbIw__"